import { ApiClient } from '@/utils/fetch'
import { SaveProductGroupOrderBody, ProductGroup } from 'shared/types/api'

export function saveProductGroupOrder(
  apiClient: ApiClient,
  venueName: string,
  productGroupNames: string[],
) {
  const body: SaveProductGroupOrderBody = {
    productGroupNames,
  }

  return apiClient.fetch(`/admin/venue/${venueName}/product-group/order`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function archiveProductGroup(
  apiClient: ApiClient,
  venueName: string,
  productGroup: ProductGroup,
) {
  return apiClient.fetch(`/admin/venue/${venueName}/product-group/${productGroup.name}`, {
    method: 'DELETE',
  })
}
